import React, {
    useState,
    useEffect,
    useContext,
    Fragment,
    useReducer,
} from 'react';
import Traductor from '../Traductor';
import Select from '../bronson/Select';
import { VehiclesContext } from '../../contexts/VehiclesContext';
import { formatPrice } from '../../js/components/shared/vehicleFunctions';
import SellService from '../../services/SellService';
import VehicleService from '../../services/VehicleService';
import ParseService from '../../services/ParseService';
import { withCookies } from 'react-cookie';
import Globals from '../../Globals';
import Loading from '../bronson/Loading';
import { UserContext } from '../../contexts/UserContext';

import '../../css/components/dealerReceptor/modalRejectVehicle.css';
import UserRejectIcon from '../../images/icons/user-reject-icon.png';
import errorTruckSvg from '../../images/icons//error-truck.svg';

function ModalRejectVehicle({ closeModal, cookies }) {
    const t = new Traductor();
    const { selectedVehicle } = useContext(VehiclesContext);
    const [loading, setLoading] = useState(false);
    const [errorRequest, setErrorRequest] = useState(false);
    const [errorRequestMessage, setErrorRequestMessage] = useState(null);
    const [sended, setSended] = useState(false);
    const [reasonTypeSelected, setReasonTypeSelected] = useState(0);
    const [reasonComment, setReasonComment] = useState('');
    const [errorTypeReason, setErrorTypeReason] = useState(false);
    const { user } = useContext(UserContext);
    const [reasonsNotBuy, setReasonsNotBuy] = useState([]);

    useEffect(() => {
        if (!selectedVehicle) closeModal();
        getReasonsType();
    }, []);

    const onChangeTypeReason = value => {
        setReasonTypeSelected(value);
        if (value == 0) setErrorTypeReason(true);
        else setErrorTypeReason(false);
    };

    const onChangeReason = e => {
        setReasonComment(e.target.value);
    };

    const closeThisModal = () => {
        if (sended) closeModal('Delete');
        else closeModal();
    };

    const printTitle = () => {
        if (sended) {
            return (
                <Fragment>
                    <img src={UserRejectIcon} style={{ width: '200px' }}></img>
                    <h1
                        className="c-modal__title u-mt-xlarge"
                        id="modal-reject-vehicle-title"
                    >
                        {' '}
                        {t.getTraduction('ModalRejectVehicle_title_rejected')}
                    </h1>
                </Fragment>
            );
        } else if (errorRequestMessage != null) {
            return (
                <Fragment>
                    <img src={errorTruckSvg} style={{ width: '200px' }}></img>
                    <h1
                        className="c-modal__title u-mt-xlarge"
                        id="modal-negotiate-vehicle-title"
                    >
                        {t.getTraduction('Oops')}
                    </h1>
                </Fragment>
            );
        } else {
            return (
                <Fragment>
                    <h1
                        className="c-modal__title"
                        id="modal-reject-vehicle-title"
                    >
                        {' '}
                        {t.getTraduction('Desestimar')}
                    </h1>
                </Fragment>
            );
        }
    };

    const getReasonsType = async () => {
        let values = [];
        values.push({ value: '', text: 'Seleccionar' });
        await new VehicleService()
            .GetNotBuyTypes(cookies.get(Globals.COOKIES.JWT).AccessToken)
            .then(response => {
                if (
                    response &&
                    response.Result != null &&
                    response.Result != ''
                ) {
                    var types = new ParseService().Parse(response.Result);
                    types.map(type => {
                        values.push({ value: type.Id, text: type.Description });
                    });
                    setReasonsNotBuy(values);
                }
            });
    };

    const printInfoContainer = () => {
        if (sended) {
            return (
                <div
                    className="c-modal__content u-pl u-pr u-pb-large u-pb-none@s"
                    role="document"
                >
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1 u-text-center">
                            <p>
                                {t.getTraduction(
                                    'ModalRejectVehicle_body_rejected'
                                )}
                            </p>
                        </div>
                    </div>
                </div>
            );
        } else if (errorRequestMessage != null) {
            return (
                <div
                    className="c-modal__content u-pl u-pr u-pb-large u-pb-none@s"
                    role="document"
                >
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1 u-text-center">
                            <p>{errorRequestMessage}</p>
                        </div>
                    </div>
                </div>
            );
        } else {
            let message = null;
            let reason = null;

            if (
                selectedVehicle.RepurchaseObligation == 0 &&
                selectedVehicle.IsReturnDealerPromoter == 1
            ) {
                //CPC
                message = (
                    <Fragment>
                        {t.getTraduction('ModalRejectVehicle_body_penalty_1') +
                            ' '}
                        <span className="u-text-alert">
                            {t.getTraduction(
                                'ModalRejectVehicle_body_penalty_2'
                            ) +
                                ' ' +
                                formatPrice(
                                    selectedVehicle.RepurchaseObligationPrice
                                )}
                        </span>
                    </Fragment>
                );
            } else if (selectedVehicle.RepurchaseObligation == 2) {
                //Renting
                message =
                    t.getTraduction('ModalRejectVehicle_body_1') +
                    ' ' +
                    t.getTraduction('ModalRejectVehicle_body_2');
            }

            reason = (
                <div className="u-mt-large">
                    <fieldset className="o-fieldset">
                        <div className="o-fieldset__row">
                            <div className="o-layout">
                                <div className="o-layout__item u-1/2 u-1/1@m">
                                    <Select
                                        onChange={e => onChangeTypeReason(e)}
                                        value={reasonTypeSelected}
                                        options={{
                                            id:
                                                'modal-reject-vehicle-reject-type',
                                            name:
                                                'modal-reject-vehicle-reject-type',
                                            type: 'text',
                                            text: t.getTraduction('ReasonType'),
                                            showLabel: true,
                                            isRequired: true,
                                            className: errorTypeReason
                                                ? 'is-error'
                                                : '',
                                            values: reasonsNotBuy,
                                            disabled: loading ? true : false,
                                        }}
                                    ></Select>
                                </div>
                            </div>
                        </div>
                        <div className="o-fieldset__row">
                            <div className="o-layout">
                                <div className="o-layout__item  u-1/1">
                                    <div className="c-form-field">
                                        {t.getTraduction('Reason')}
                                        <div className="c-form-field__box">
                                            <div className="c-input c-input--textarea">
                                                <textarea
                                                    className="c-input__input"
                                                    id="modal-reject-vehicle-comment"
                                                    cols="30"
                                                    rows="4"
                                                    placeholder=""
                                                    value={reasonComment}
                                                    onChange={e =>
                                                        onChangeReason(e)
                                                    }
                                                    disabled={
                                                        loading ? true : false
                                                    }
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
            );

            return (
                <div
                    className="c-modal__content u-mt u-pt@xl u-pt@l u-pt-none@s u-pb-large u-pb-none@s"
                    role="document"
                >
                    <div className="o-layout">
                        <div className="o-layout__item u-1/1">
                            <p className="u-bg-pale u-text-center u-p u-mb-none">
                                {message}
                            </p>
                        </div>
                    </div>
                    {reason}
                </div>
            );
        }
    };

    const printFooterButtons = () => {
        let content = null;
        if (sended || errorRequestMessage != null) {
            content = (
                <div className="c-modal__actions__item">
                    <button
                        className="c-btn c-btn--secondary js-modal-close"
                        disabled={loading ? true : false}
                        aria-label="Cerrar"
                        onClick={() => closeThisModal()}
                    >
                        <span className="c-btn__text">
                            {t.getTraduction('Close')}
                        </span>
                    </button>
                </div>
            );
        } else {
            content = (
                <Fragment>
                    <div className="c-modal__actions__item">
                        <button
                            className="c-btn c-btn--secondary js-modal-close"
                            disabled={loading ? true : false}
                            aria-label="Volver atrás"
                            onClick={() => closeModal('Prev')}
                        >
                            <span className="c-btn__text">
                                {t.getTraduction('Back')}
                            </span>
                        </button>
                    </div>
                    <div className="c-modal__actions__item">
                        <button
                            className="c-btn js-modal-close js-modal-autofocus"
                            disabled={loading ? true : false}
                            aria-label="Desestimar vehiculo"
                            onClick={validate}
                        >
                            <span className="c-btn__text">
                                {t.getTraduction('DismissPurchase')}
                            </span>
                        </button>
                    </div>
                </Fragment>
            );
        }
        if (content == null) return null;
        return (
            <div className="c-modal__footer">
                {errorRequest ? (
                    <p className="c-error-message u-text-center u-mb">
                        {t.getTraduction('RequestErrorMessage')}
                    </p>
                ) : null}
                <div className="c-modal__actions">{content}</div>
            </div>
        );
    };

    const validate = () => {
        if (selectedVehicle.RepurchaseObligation == 2) {
            if (reasonTypeSelected == 0) {
                setErrorTypeReason(true);
            } else {
                setErrorTypeReason(false);
                save();
            }
        } else save();
    };

    const save = async () => {
        setLoading(true);
        setErrorRequest(false);
        let data = {
            Vehicle: selectedVehicle,
            CounterOfferPrice: null,
            NotBuyType: reasonTypeSelected,
            Observations: reasonComment,
            ProfileId: user.data.Profile,
            EmployeId: user.data.Empleado.Id,
            CIF: user.data.DocumentId,
        };
        await new SellService()
            .negotiateVehicle(
                data,
                cookies.get(Globals.COOKIES.JWT).AccessToken
            )
            .then(response => {
                if (
                    response &&
                    response.statusCode == 200 &&
                    response.body.Result != null &&
                    response.body.Result == 'true'
                ) {
                    setSended(true);
                } else {
                    if (
                        response &&
                        response.body &&
                        response.body.Errors &&
                        response.body.Errors.length > 0
                    ) {
                        setErrorRequestMessage(response.body.Errors[0].Value);
                    } else {
                        setErrorRequest(true);
                    }
                }
            });
        setLoading(false);
    };
    return (
        <Fragment>
            <div
                className="c-modal"
                aria-hidden="false"
                id="modal-reject-vehicle"
            >
                <div
                    className="c-modal__overlay  js-modal-close"
                    tabIndex="-1"
                ></div>
                <div
                    className="c-modal__wrapper"
                    role="dialog"
                    aria-labelledby="modal-reject-vehicle-title"
                >
                    <header className="c-modal__header">
                        <button
                            className="c-modal__close-btn  js-modal-close"
                            type="button"
                            aria-label="Cerrar modal."
                            onClick={closeThisModal}
                        ></button>
                        <div className="c-modal__title__wrapper">
                            {printTitle()}
                        </div>
                    </header>
                    {printInfoContainer()}
                    {printFooterButtons()}
                </div>
            </div>
            <Loading ariaBusy={loading}></Loading>
        </Fragment>
    );
}

export default withCookies(ModalRejectVehicle);
